import { SagaIterator } from 'redux-saga';
import { EVALUATION_RESET } from 'src/modules/evaluation/actions/EvaluationActions';
import { logDebug } from 'src/sagas/utils/logging';
import { call, put } from 'typed-redux-saga';

export function* resetEvaluation(): SagaIterator<void> {
  yield* call(logDebug, 'Resetting evaluation data...');
  yield* put(EVALUATION_RESET.trigger());
  yield* call(logDebug, 'Resetting evaluation data... done');
}
